import {onFind} from "@elements/init-modules-in-scope";
import {on, find} from "@elements/dom-utils";
import * as formValidation from '@elements/form-validation';

export function init() {
    onFind('.js-form-tracking', function (trackingForm) {
        formValidation.getApi(trackingForm).then((formApi) => {
            let formInstance = formApi.getFormInstance();

            on('submit', (evt) =>  {
                formInstance.validate().then((state) => {
                    if (state !== 'Valid') {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            event: 'checkout_error',
                            error_message: 'form field(s) missing',
                        });
                    }
                });
            }, trackingForm);
        });
    });
}